import { ISedmsFormModel } from 'src/app/shared/interfaces/form/sedms-form-model';

export const AddCaseClosingFormModel: ISedmsFormModel = {
    caseActionSk : {
        name: 'caseActionSk',
    },
    caseActionType: {
        name: 'caseActionType',
    },
    reason: {
        name: 'reason',
        required: true
    },
    reasonForDelays: [
        {
            name: 'reasonForDelayId'
        },
        {
            name: 'caseActionSk'
        },
        {
            name: 'description'
        },
        {
            name: 'stageId'
        }
    ],
    dischargeReason: {
        name: 'dischargeReason',
    },
    dischargeDate: {
        name: 'dischargeDate',
    },
    dischargeStatus: {
        name: 'dischargeStatus',
    },
    openOrClose: {
        name: 'openOrClose',
    },
    closeDate:{
        name: 'closeDate',
        required: true
    },
    outreach:{
        name: 'outreach'
    },
    withdrawal:{
        name: 'withdrawal'
    },
    process:{
        name: 'process',
    },
    prompt:{
        name: 'prompt'
    },
    referral:{
        name: 'referral'
    },
    
    phone:{
        name :'phone'
    },
    placement:{
        name :'placement'
    },
    outreachDays:{
        name:'outreachDays'
    },
    revocationConsent:{
        name:'revocationConsent'
    },
    elapsed:{
        name :'elapsed'
    },
    ineligibilityLetter:{
        name :'ineligibilityLetter'
    },
    pwnRecommendation:{
        name: 'pwnRecommendation'
    },
    declassificationDocument:{
        name :'declassificationDocument'
    },
    projectedDate:{
        name:'projectedDate'
    },
    declassificationParent:{
        name:'declassificationParent'
    },
    dischargeReasons:{
        name :'dischargeReasons'
    },
    requiresImpartial:{
        name:'requiresImpartial',
        required: true
    }
}